import { Link } from '@/components/Link'
import { Icon } from '@/components/Icon'
import { getAppConfig } from '@/config/config'
const config = getAppConfig()

type SocialLinkProps = {
  variant: 'facebook' | 'instagram' | 'x' | 'mastodon' | 'rss'
  className?: string
}

const SocialLink = ({ variant, className }: SocialLinkProps) => {
  const linkUrl = config.social[variant] ?? '#'
  return (
    <Link href={linkUrl} target={'_blank'} className={className} aria-label={variant}>
      <Icon name={variant as any} size={24} />
    </Link>
  )
}

export default SocialLink
